import styled from 'styled-components'

export const HeaderWrapper = styled.div.attrs(({ theme }) => ({
  display: theme.layout.header || theme.layout.header === undefined ? 'block' : 'none',
}))`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;

  padding: 0 100px;
  height: fit-content;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.backgroundLite};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
  line-height: unset;
  font-weight: 500;

  // Themed Properties
  display: ${({ display }) => display};
  display: flex;
  align-items: flex-end;
  justify-content: 'space-between';
  height: 50px;
`

export const HeaderInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: unset;
  padding: 12px ;
`

export const HeaderTitle = styled.div`
  display: flex;
  gap: 10px;

  & button {
    font-size: 20px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary};

    padding: 0;
    background: transparent;
    border: 0px;
    & svg {
      max-width: none !important;
      max-height: none !important;
    }
    & svg > path {
      stroke: ${({ theme }) => theme.colors.brand};
    }
  }
  & button:hover {
    background: transparent;
    border: 0px;
    & svg > path {
      stroke: ${({ theme }) => theme.colors.brand};
    }
  }

  font-size: 16px;
  font-weight: 600; 
  color: ${({ theme }) => theme.colors.primary};
`

export const SubHeaderIconWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  & svg path {
    stroke: ${({ theme }) => theme.colors.secondary};
  }
`
export const SubHeaderWrapper = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: flex-start;  
  align-items: flex-end;
  background-color: ${({ theme }) => theme.colors.backgroundLite};
`

export const SubHeaderContent = styled.div`
  max-width: 1080px;
 
`
